import React from 'react';
import ShortForm from './ShortForm';
import Page from './Page';

export default class Message extends Page {

	render(){
		return (
			<ShortForm label={this.app.messagePage.title}>
				{this.app.messagePage.body}
			</ShortForm>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Message.js